import React from "react";

export const BeverageIcon = (props) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25 20C25 17.2386 27.2386 15 30 15H70C72.7614 15 75 17.2386 75 20V30H25V20ZM25 35H75V75C75 80.5228 70.5228 85 65 85H35C29.4772 85 25 80.5228 25 75V35ZM30 40V75C30 77.7614 32.2386 80 35 80H65C67.7614 80 70 77.7614 70 75V40H30ZM40 50H60V70H40V50Z"
      fill="currentColor"
    />
  </svg>
);
